import type { Disclosure } from "@msuite/ui/hooks";
import { resolver } from "@msuite/ui/libs/form";
import type { RefetchFn } from "@msuite/ui/query";
import { getUserSchema } from "@msuite/utils/schemas";
import { Fragment } from "react";
import { useForm, useWatch } from "react-hook-form";
import { UserPicker } from "@/components/pickers/user-picker";
import { AddAbsenceModal } from "@/modals/users/add-absence-modal";

/** Props Interface */
interface AbsencesInboxModalsProps {
	addAbsenceModal: Disclosure;
	onRefetch: RefetchFn;
}

export function AbsencesInboxModals({ addAbsenceModal, onRefetch }: AbsencesInboxModalsProps) {
	/** Hooks */
	const methods = useForm({ resolver: resolver(getUserSchema) });
	const userId = useWatch({ control: methods.control, name: "userId" });

	/** Render */
	return (
		<Fragment>
			{addAbsenceModal.isOpen && (
				<AddAbsenceModal
					isOpen={addAbsenceModal.isOpen}
					onClose={addAbsenceModal.onClose}
					onComplete={onRefetch}
					userId={userId}
					isDisabled={!userId}
					header={
						<UserPicker
							control={methods.control}
							name="userId"
							isNullable={false}
						/>
					}
				/>
			)}
		</Fragment>
	);
}
